export default{

    lista:{
        method:'get',
        url:'vale/lista'
    },
    cadastra:{
        method:'post',
        url:'vale/cadastro'
    },
    delete:{
        method:'delete',
        url:'vale/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'vale/editar{/id}'
    },
    duplicar:{
        method:'get',
        url:'vale/ferramenta/duplicar{/id}'
    },
    update:{
        method:'post',
        url:'vale/update'
    },
    confirmacao:{
        method:'post',
        url:'vale/ferramenta/boletim/cadastro'
    },
    analizer:{
        method:'post',
        url:'vale/ferramenta/boletim/cadastro/analizer'
    },
    rejeita:{
        method:'post',
        url:'vale/ferramenta/boletim/cadastro/rejeita'
    },
}